/**
 * Pause / Play controls for videos
 * @author Matt Haynes <matthew.haynes@joipolloi.com>
 * @package The University of Sheffield - Performance Venues
 */

export default class VideoPausePlay {
    constructor(elem) {
        if (!elem) {
            return;
        }
        this.elem = elem;
        this.playing = true;

        // Add event listener to video element, play button + pause button
        [...this.elem.parentElement.children].forEach(child => {
            child.addEventListener('click', () => {
                if (this.playing) {
                    this.pause();
                } else {
                    this.play();
                }
            });
        });
    }

    pause() {
        this.elem.pause();
        this.playing = false;
        this.elem.parentElement.classList.remove('playing');
        this.elem.parentElement.classList.add('paused');
    }

    play() {
        this.elem.play();
        this.playing = true;
        this.elem.parentElement.classList.remove('paused');
        this.elem.parentElement.classList.add('playing');
    }
}
